import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import { store } from '@/store'
import { insuranceRoutes } from '@/router/insurance'

Vue.use(VueRouter)

/** ================================================================================ **/

const adminRoutes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: { name: 'insurance-partner/view-orders' }
  }
  // {
  //   path: '/restaurants',
  //   name: 'restaurants',
  //   component: () => import('@/views/Restaurants.vue'),
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  // {
  //   path: '/restaurants/:id',
  //   name: 'restaurantDetail',
  //   component: () => import('@/views/RestaurantDetail.vue'),
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  // {
  //   path: '/hotels',
  //   name: 'hotels',
  //   component: () => import('@/views/Hotels.vue'),
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
]

/** ================================================================================ **/

const rewardPartnerRoutes: Array<RouteConfig> = [
  {
    path: '/partner/shops',
    name: 'partner-select-shop',
    component: () => import(/* webpackChunkName: "rewardPartner" */ '@/views/partner/SelectShop.vue'),
    meta: {
      requiresAuth: true,
      roles: ['admin', 'reward_partner']
    }
  },
  {
    path: '/partner/claims',
    name: 'partner-claims',
    component: () => import(/* webpackChunkName: "rewardPartner" */ '@/views/partner/Claims.vue'),
    meta: {
      requiresAuth: true,
      roles: ['admin', 'reward_partner']
    }
  }
]

/** ================================================================================ **/

const otherRoutes: Array<RouteConfig> = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/forbidden',
    name: 'forbidden',
    component: () => import('@/views/403.vue')
  }
]

const _router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...otherRoutes,
    ...adminRoutes,
    ...rewardPartnerRoutes,
    ...insuranceRoutes
  ]
})

_router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters['user/isLoggedIn']) {
      return next({ name: 'login' })
    }

    const routeRoles = to.meta !== undefined && to.meta.roles !== undefined ? to.meta.roles : []
    if (!store.getters['user/hasRoles'](routeRoles)) {
      return next({ name: 'forbidden' })
    }

    return next()
  } else {
    next() // make sure to always call next()!
  }
})

export const router = _router
